import react from "react";


let Footer=()=>{
    return(
        <footer><strong>Made by Nikhil using React.</strong></footer>
    )
}

export default Footer